import { cn } from '@/utils/utils';
import type { LucideIcon, LucideProps } from 'lucide-react';
import type { MouseEventHandler } from 'react';
import type React from 'react';

const sizes = {
  xxs: 10,
  xs: 12,
  sm: 14,
  md: 15,
  lg: 20,
  xl: 24,
  '2xl': 30,
  '3xl': 48,
};
export interface IconProps extends React.SVGProps<SVGSVGElement> {
  as: LucideIcon | ((props: LucideProps) => React.JSX.Element) | null;
  size?: keyof typeof sizes;
  onClick?: MouseEventHandler<SVGSVGElement>;
  strokeWidth?: number; // Added strokeWidth prop
}

export const Icon = ({
  as: IconComponent,
  size = 'md',
  className,
  onClick,
  strokeWidth = 2,
  ...rest // Capture the rest of the props
}: IconProps) => {
  if (!IconComponent) return null;
  return (
    <IconComponent
      onClick={onClick}
      width={sizes[size]}
      height={sizes[size]}
      className={cn(className)}
      strokeWidth={strokeWidth}
      {...rest} // Spread the rest of the props here
    />
  );
};
